const taskIsComplete = task => task.complete

export default taskIsComplete